module.exports = __webpack_public_path__ + "img/v-code.da658371.png";